<section id="posibilidades">
  <div class="all-content-slides-container">
    <img class="green-lines" src="{{ images.greenLines }}" alt="">

    <div class="title-slides">
      <span>Financiamiento inteligente</span>
      <span> para negocios con visión</span>
    </div>

    <div class="slider-image-container">
      <div class="image-box" style="background-color: #000;">

        <!-- Imagen actual -->
        <img
          [src]="currentSlide.src"
          class="slide-img"
          [@fadeImg]="currentImgState"
          alt="slide actual"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; z-index: 0;"
        >
        <!-- Imagen siguiente -->
        <img
          [src]="nextSlide.src"
          class="slide-img"
          [@fadeImg]="nextImgState"
          alt="slide siguiente"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; z-index: 0;"
        >

        <div class="descriptive">

          <div class="descriptive-text"
              [ngStyle]="{
                'position': 'absolute',
                'top': '-135px'
              }"
              [@fadeText]="textState"
              *ngIf="isActive === 'maquinaria'">
            <p>Utiliza tu crédito para</p>
            <!-- Maquinaria -->
            <p>Modernizar tu producción, adquirir nueva maquinaria o renovar tu equipo actual.</p>
            <p>El crecimiento empieza con mejores herramientas. Equipa tu empresa para operar más rápido, con mayor precisión y eficiencia.</p>
          </div>

          <div class="descriptive-text"
              [ngStyle]="{
                'position': 'absolute',
                'top': '-135px'
              }"
              [@fadeText]="textState"
              *ngIf="isActive === 'instalacion'">
            <p>Utiliza tu crédito para</p>
            <!-- Instalacion -->
            <p>Expandir tus instalaciones, remodelar oficinas o abrir una nueva sucursal.</p>
            <p>¿Tu espacio ya no es suficiente? Es momento de crecer tu infraestructura sin frenar tu operación. En DRAM financiamos tu siguiente paso.</p>
          </div>

          <div class="descriptive-text"
              [ngStyle]="{
                'position': 'absolute',
                'top': '-135px'
              }"
              [@fadeText]="textState"
              *ngIf="isActive === 'insumos'">
            <p>Utiliza tu crédito para</p>
            <!-- Insumos -->
            <p>Re-abastecer tu inventario, asegurar materia prima o aprovechar descuentos por volumen.</p>
            <p>Mantén tu operación activa sin comprometer flujo de efectivo. Te ayudamos a financiar compras clave para tu negocio.</p>
          </div>

          <div class="descriptive-text"
              [ngStyle]="{
                'position': 'absolute',
                'top': '-135px'
              }"
              [@fadeText]="textState"
              *ngIf="isActive === 'nuevoPersonal'">
            <p>Utiliza tu crédito para</p>
            <!-- Nuevo Personal -->
            <p>Expandir tu equipo, contratar talento clave o fortalecer tu operación.</p>
            <p>El crecimiento de tu empresa comienza con las personas adecuadas. Si estás listo para escalar, nosotros te ayudamos a cubrir la inversión en capital humano.</p>
          </div>

        </div>

        <button-credito
            [texto]="'Solicitar crédito'"
            [icono]="icons.buttonCircle"
            [ngStyle]="{
              'position': 'absolute',
              'bottom': '183.66px'
            }"
          ></button-credito>
      </div>
    </div>
    <div class="container-scroll">
        <div class="slider-buttons-container" scrollX="true">
            <button [ngClass]="{'active': isActive === 'maquinaria'}" (click)="setActiveSlide('maquinaria')">Maquinaria</button>
            <button [ngClass]="{'active': isActive === 'instalacion'}" (click)="setActiveSlide('instalacion')">Instalacion</button>
            <button [ngClass]="{'active': isActive === 'insumos'}" (click)="setActiveSlide('insumos')">Insumos</button>
            <button [ngClass]="{'active': isActive === 'nuevoPersonal'}" (click)="setActiveSlide('nuevoPersonal')">Nuevo personal</button>
        </div>
    </div>
    <img class="hero-sphere-6" src="{{ icons.sphere1 }}" alt="">
  </div>
</section>
